import React, { useState } from 'react';
import AdminSearchTable from '../Admin/AdminSearchTable'
import { useNavigate } from 'react-router-dom';
import EmptyHeader from '../Shared/EmptyHeader';
import { useAuth } from "../../src/Context/AuthContext"

const AgentSearchSection = () => {
    //State Variables
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [entityName, setEntityName] = useState('');
    const [agtCode, setAgtCode] = useState('');
    const [results, setResults] = useState([]);
    const [noItemsFound, setNoItemsFound] = useState(false);
    const navigate = useNavigate();
    const { logout } = useAuth();

    //ENV Variables
    const apiURL = import.meta.env.VITE_API;

    const columns = [
        { label: 'Agent Code', accessor: 'agtCode' },
        { label: 'Name', accessor: 'displayName' },
        { label: 'Portal UserName', accessor: 'portalUserName' },
    ];

    const formatDate = (dateStr) => {
        if (!dateStr) return 'N/A';
        const d = new Date(dateStr);
        return isNaN(d) ? 'N/A' : d.toLocaleDateString();
    };

    const searchByName = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiURL}/admin/searchAgent/by-name?firstName=${firstName}&lastName=${lastName}`, {
                method: "GET",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (res.status === 404) {
                // No items found (API should return 404 in this case)
                setResults([]); // Clear results if needed
                setNoItemsFound(true); // Custom state to show message
                return;
            }

            if (!res.ok) {
                const text = await res.text(); // log raw error response
                throw new Error(`Request failed: ${res.status} ${res.statusText}\n${text}`);
            }

            const data = await res.json();
            setResults(data);
            setNoItemsFound(data.length === 0);
        } catch (err) {
            console.error('Error fetching by name:', err);
            alert("An error occurred while fetching data. Check the console for details.");
        }
    };

    const searchByEntity = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiURL}/admin/searchAgent/by-entity?entityName=${entityName}`, {
                method: "GET",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (res.status === 404) {
                // No items found (API should return 404 in this case)
                setResults([]); // Clear results if needed
                setNoItemsFound(true); // Custom state to show message
                return;
            }

            if (!res.ok) {
                const text = await res.text(); // log raw error response
                throw new Error(`Request failed: ${res.status} ${res.statusText}\n${text}`);
            }

            const data = await res.json();
            setResults(data);
            setNoItemsFound(data.length === 0);
        } catch (err) {
            console.error('Error fetching by name:', err);
            alert("An error occurred while fetching data. Check the console for details.");
        }
    };

    const searchByAgtCode = async (e) => {
        e.preventDefault();
        try {
            const res = await fetch(`${apiURL}/admin/searchAgent/by-agtCode?agtCode=${agtCode}`, {
                method: "GET",
                credentials: "include"
            });

            if (res.status === 401) {
                logout();
                navigate('/login');
                throw new Error("unauthorized");
            }

            if (res.status === 403) {
                navigate('/home');
                throw new Error("forbidden");
            }

            if (res.status === 404) {
                // No items found (API should return 404 in this case)
                setResults([]); // Clear results if needed
                setNoItemsFound(true); // Custom state to show message
                return;
            }

            if (!res.ok) {
                const text = await res.text(); // log raw error response
                throw new Error(`Request failed: ${res.status} ${res.statusText}\n${text}`);
            }

            const data = await res.json();

            if (data.length === 1) {
                navigate(`/agent/${data[0].agtCode}`)
            }

            setResults(data);
            setNoItemsFound(data.length === 0);
        } catch (err) {
            console.error('Error fetching by agent code:', err);
            alert("An error occurred while fetching data. Check the console for details.");
        }
    };

    return (
        <div className="admin-search-page" id="policy-search-container">

            <div className="admin-search-columns">
                <div className="search-card">
                    <h5>Search by Agent Name</h5>
                    <form className="baseForm" onSubmit={searchByName}>
                        <label className="baseLabel">First Name</label>
                        <input
                            type="text"
                            value={firstName}
                            className="baseInput"
                            onChange={(e) => setFirstName(e.target.value)}
                            placeholder="e.g. John"
                        />
                        <label className="baseLabel">Last Name</label>
                        <input
                            type="text"
                            value={lastName}
                            className="baseInput"
                            onChange={(e) => setLastName(e.target.value)}
                            placeholder="e.g. Smith"
                        />
                        <button type="submit" className="baseButton">Search</button>
                    </form>
                </div>
                <div className="search-card">
                    <h5>Search by Agent Entity Name</h5>
                    <form className="baseForm" onSubmit={searchByEntity}>
                        <label className="baseLabel">Entity Name</label>
                        <input
                            type="text"
                            value={entityName}
                            className="baseInput"
                            onChange={(e) => setEntityName(e.target.value)}
                            placeholder="e.g. Example Agency"
                        />
                        <button type="submit" className="baseButton">Search</button>
                    </form>
                </div>

                <div className="search-card">
                    <h5>Search by Agent Code</h5>
                    <form className="baseForm" onSubmit={searchByAgtCode}>
                        <label className="baseLabel">Agent Code</label>
                        <input
                            type="text"
                            value={agtCode}
                            className="baseInput"
                            onChange={(e) => setAgtCode(e.target.value)}
                            placeholder="e.g. 5000000"
                        />
                        <button className="baseButton" type="submit" >Search</button>
                    </form>
                </div>
            </div>

            <EmptyHeader/>
            {results.length > 0 && (
                <AdminSearchTable columns={columns} data={results} /> 
            )}

            {noItemsFound && (
                <div className="no-items-message">
                    No Agents found.
                </div>
            )}
        </div>
    );
};

export default AgentSearchSection;
